import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectAccessSystem = createSelector(selectJsonQuery, jsonQuery => getTermValue('enter')(jsonQuery));
